<ui-button
  mode="ghost"
  class="block"
  expand="full"
  uiPopover
  [anchor]="uiPopover"
  popoverEvent="click"
>
  <ui-loading-spinner size="20" slot="start" />
  {{ 'cockpit.parseRequests.activeDropdown.title' | transloco }}
  <div class="flex h-5" slot="end">
    <ui-badge color="error" mode="filled" [iconOnly]="true" rounded="full" class="block -mt-[2px]">
      {{ activeParseRequests().length }}
    </ui-badge>
  </div>
</ui-button>

<ui-popover popover #uiPopover>
  <ui-dropdown-popover-layout>
    <ul>
      @for (parseRequest of activeParseRequests(); track parseRequest.id) {
        <li>
          <ui-dropdown-option (click)="uiPopover.hide(); clickParseRequest.emit(parseRequest.id)">
            @if (parseRequest.data?.metadata?.createdAt; as createdAt) {
              {{
                'cockpit.parseRequests.activeDropdown.itemTitle'
                  | transloco
                    : {
                        date: (createdAt | date: 'dd.MM.yyyy'),
                        time: (createdAt | date: 'HH:mm'),
                      }
              }}
            }
          </ui-dropdown-option>
        </li>
      }
    </ul>
  </ui-dropdown-popover-layout>
</ui-popover>
